import React, { useEffect, useState } from 'react'
import Navbar from './components/Navbar'
import Sidebar from './components/Sidebar'
import Overview from './pages/dashboard/Overview'
import { Route, Routes, useNavigate } from 'react-router-dom'
import CourseForm from './components/CourseForm'
import ChallengeForm from './components/ChallengeForm'
import EditCourseForm from './components/EditCourseForm'
import EditChallengeForm from './components/EditChallengeForm'
import ChallengeSubmissions from './components/ChallengeSubmissions'
import ChallengeVideoPlayer from './components/ChallengeVideoPlayer'
import Courses from './pages/dashboard/Courses'
import Challenges from './pages/dashboard/Challenges'
import Login from './pages/auth/Login'
import PrivateRoute from './components/PrivateRoute'
import FilledButton from './components/ui/FilledButton'
import Missions from './pages/dashboard/Missions'
import MissionForm from './components/MissionForm'

const App = () => {
  const [auth, setAuth] = useState(false);

  const updateAuth = (val) => setAuth(val);

  const navigate = useNavigate();

  useEffect(() => {
    auth?navigate('/',{ replace:true }):navigate('/login',{ replace:true });
  },[auth]);

  return (
    <div>
      <Navbar />
      <div className='flex'>
        {auth && <div className='w-72 hidden sm:flex'><Sidebar /></div>}
        <div className='flex-1 p-4 border border-blue-500 h-screen overflow-y-scroll overflow-x-hidden'>
          <Routes>
            <Route path='/'>
              <Route index element={auth?<Overview />:<PrivateRoute />} />
              <Route path='courses' element={auth?<Courses />:<PrivateRoute />} />
              <Route path='challenges' element={auth?<Challenges />:<PrivateRoute />} />
              <Route path='missions' element={auth?<Missions />:<PrivateRoute />} />
              <Route path='courses/edit/:courseId' element={auth?<EditCourseForm />:<PrivateRoute />} />
              <Route path='challenges/edit/:challengeId' element={auth?<EditChallengeForm />:<PrivateRoute />} />
              <Route path='courses/create' element={auth?<CourseForm />:<PrivateRoute />} />
              <Route path='challenges/create' element={auth?<ChallengeForm />:<PrivateRoute />} />
              <Route path='missions/create' element={auth?<MissionForm />:<PrivateRoute />} />
              <Route path='submissions' element={auth?<ChallengeSubmissions />:<PrivateRoute />} />
              <Route path='submissions/play/:videoId' element={auth?<ChallengeVideoPlayer />:<PrivateRoute />} />
              <Route path='login' element={!auth?<Login auth={auth} updateAuth={updateAuth} />:<FilledButton label={'logout'} onClick={() => updateAuth(false)} />} />
            </Route>
            <Route path='*' element={'Page Not Found'} />
          </Routes>
        </div>
      </div>
    </div>
  )
}

export default App